// Card.jsx
// Client: vmfive
// Version: 1.0.0

import './Card.css';

export default function Card({ children, className = '', ...rest }) {
  return (
    <div className={`card ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function CardHeader({ children, highlighted = false, className = '', ...rest }) {
  return (
    <div
      className={`card-header ${highlighted ? 'card-header-highlighted' : ''} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardBody({ children, className = '', ...rest }) {
  return (
    <div className={`card-body ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function CardFooter({ children, className = '', ...rest }) {
  return (
    <div className={`card-footer ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function CardImage({ src, alt = '', gradient, className = '', ...rest }) {
  return (
    <div
      className={`card-image ${className}`}
      style={gradient ? { background: gradient } : undefined}
      {...rest}
    >
      {src && <img src={src} alt={alt} />}
    </div>
  );
}
